/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosNftSchedulerControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public supplementAllCollectionTokenMetadata(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/nft/supplement',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public set(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/nft/latest',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public setGiftielMetadata(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/nft/giftiel',
        });
    }

}
